module.exports = __webpack_public_path__ + "static/media/bhupeshpatil.7eb2c744.jpg";